import { tsrContractsClient } from '../tsrContractsClient';

export const patientStudiesClient = () => tsrContractsClient.patientStudiesContract;
